var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (groups, partner, undefined) {
buf.push("<div class=\"artists-grid\">");
// iterate groups
;(function(){
  var $$obj = groups;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var group = $$obj[$index];

buf.push("<section class=\"artists-grid-section\"><h2 class=\"avant-garde-header-center artists-group-label\">" + (jade.escape(null == (jade_interp = group.label) ? "" : jade_interp)) + "</h2><div class=\"partner-artists-container\">");
// iterate group.list
;(function(){
  var $$obj = group.list;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var pa = $$obj[$index];

if ( pa.get('published_artworks_count') > 0 && pa.get('display_on_partner_profile') === true)
{
buf.push("<figure" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + " class=\"partner-artist\"><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner-route-link\"><div class=\"partner-artist-cover-image\"><img" + (jade.attr("src", "" + (pa.imageUrl('four_thirds')) + "", true, true)) + (jade.attr("alt", pa.get('artist').name, true, true)) + "><div class=\"partner-artist-overlay\"></div></div><figurecaption class=\"partner-artist-caption\"><h5 class=\"partner-artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</h5></figurecaption></a></figure>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var pa = $$obj[$index];

if ( pa.get('published_artworks_count') > 0 && pa.get('display_on_partner_profile') === true)
{
buf.push("<figure" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + " class=\"partner-artist\"><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner-route-link\"><div class=\"partner-artist-cover-image\"><img" + (jade.attr("src", "" + (pa.imageUrl('four_thirds')) + "", true, true)) + (jade.attr("alt", pa.get('artist').name, true, true)) + "><div class=\"partner-artist-overlay\"></div></div><figurecaption class=\"partner-artist-caption\"><h5 class=\"partner-artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</h5></figurecaption></a></figure>");
}
    }

  }
}).call(this);

buf.push("</div></section>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var group = $$obj[$index];

buf.push("<section class=\"artists-grid-section\"><h2 class=\"avant-garde-header-center artists-group-label\">" + (jade.escape(null == (jade_interp = group.label) ? "" : jade_interp)) + "</h2><div class=\"partner-artists-container\">");
// iterate group.list
;(function(){
  var $$obj = group.list;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var pa = $$obj[$index];

if ( pa.get('published_artworks_count') > 0 && pa.get('display_on_partner_profile') === true)
{
buf.push("<figure" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + " class=\"partner-artist\"><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner-route-link\"><div class=\"partner-artist-cover-image\"><img" + (jade.attr("src", "" + (pa.imageUrl('four_thirds')) + "", true, true)) + (jade.attr("alt", pa.get('artist').name, true, true)) + "><div class=\"partner-artist-overlay\"></div></div><figurecaption class=\"partner-artist-caption\"><h5 class=\"partner-artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</h5></figurecaption></a></figure>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var pa = $$obj[$index];

if ( pa.get('published_artworks_count') > 0 && pa.get('display_on_partner_profile') === true)
{
buf.push("<figure" + (jade.attr("data-artist-id", pa.get('artist').id, true, true)) + " class=\"partner-artist\"><a" + (jade.attr("href", pa.href(), true, true)) + " class=\"partner-route-link\"><div class=\"partner-artist-cover-image\"><img" + (jade.attr("src", "" + (pa.imageUrl('four_thirds')) + "", true, true)) + (jade.attr("alt", pa.get('artist').name, true, true)) + "><div class=\"partner-artist-overlay\"></div></div><figurecaption class=\"partner-artist-caption\"><h5 class=\"partner-artist-name\">" + (jade.escape(null == (jade_interp = pa.get('artist').name) ? "" : jade_interp)) + "</h5></figurecaption></a></figure>");
}
    }

  }
}).call(this);

buf.push("</div></section>");
    }

  }
}).call(this);

buf.push("<section class=\"artists-grid-section\"><div class=\"partner-artists-see-all avant-garde-header-center\"><a" + (jade.attr("href", "" + (partner.href()) + "/artists", true, true)) + " class=\"faux-underline-hover partner-route-link\">Go to artists</a></div></section></div>");}.call(this,"groups" in locals_for_with?locals_for_with.groups:typeof groups!=="undefined"?groups:undefined,"partner" in locals_for_with?locals_for_with.partner:typeof partner!=="undefined"?partner:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;